import Vue from "vue";
import Vuex from "vuex";
import VuexPersisrence from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersisrence({
  storage: window.localStorage
});

export default new Vuex.Store({
  state: {
    cart: {}
  },
  getters: {},
  mutations: {
    addToCart(state, { productId, quantity }) {
      if (state.cart[productId]) {
        Vue.set(state.cart, productId, state.cart[productId] + quantity);
      } else {
        Vue.set(state.cart, productId, 1);
      }
    },
    emptyCart(state) {
      const allKeys = Object.keys(state.cart);
      for (const key of allKeys) {
        Vue.delete(state.cart, key);
      }
    }
  },
  modules: {},
  plugins: [vuexLocal.plugin]
});
